import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

interface ReviewTextViewerProps {
  text: string;
}

export function ReviewTextViewer({ text }: ReviewTextViewerProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Could not copy to clipboard');
    }
  };

  return (
    <div className="relative flex h-full w-full flex-col bg-muted/30">
      <div className="absolute right-3 top-3 z-10">
        <Button variant="outline" size="sm" onClick={handleCopy}>
          {copied ? (
            <>
              <Check className="h-3.5 w-3.5 mr-1.5" />
              Copied
            </>
          ) : (
            <>
              <Copy className="h-3.5 w-3.5 mr-1.5" />
              Copy
            </>
          )}
        </Button>
      </div>
      <pre className="flex-1 overflow-auto whitespace-pre-wrap p-4 pr-24 font-mono text-xs leading-relaxed text-foreground">
        {text}
      </pre>
    </div>
  );
}
